module.exports = __webpack_public_path__ + "static/images/dialog-gift-bg.6daf919.png";